import { WalletDr } from '../containers';

const ConnectWalletDr = () => {
  return (
    <div>
        <div className="Connect-Wallet-dr">
          <WalletDr />
        </div>
    </div>
  )
}

export default ConnectWalletDr